import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MODAL_DATA } from '../../../helpers/modal.tokens';
import { DataManipulationService } from '../../../services/data-manipulation.service';

export interface ActionDetailsModalData {
  action: any;
  statement: any;
  withStatements: boolean;
  taskStatements: any[];
  actionsStatus: { title: string, type: string, color: string }[];
  baseUrl: string;
  onStatusChange: (status: any) => void;
}

export type ActionDetailsModalResult =
  { type: 'assignToMe' } |
  { type: 'assign', member: any } |
  { type: 'notRelevant' };

@Component({
  selector: 'app-action-details-modal',
  templateUrl: './action-details-modal.component.html',
  styleUrls: ['./action-details-modal.component.scss']
})
export class ActionDetailsModalComponent {
  selectedActionStatus: any;
  selectedTeamLeader: any;

  constructor(@Inject(MODAL_DATA) public config: ActionDetailsModalData,
              private dialogRef: MatDialogRef<any>,
              public data: DataManipulationService) {
    if (config.withStatements) {
      this.selectedActionStatus = {type: config.action.status};
    }
  }

  close(result?: ActionDetailsModalResult) {
    this.dialogRef.close(result);
  }
}
